export default __webpack_public_path__ + "static/media/add.35cc81d4.svg";